import { FC } from 'react';
import { useLogging } from '../../../hooks/common/useLogging';
import { ProductInfo } from '../../../hooks/SubscriptionDetail/useRegisteredProducts';
import { RecommendProductInfo } from '../../../hooks/SubscriptionDetail/useRecommendProducts';
import { ExtendData } from '../../../hooks/App/useGetExposeExtendDataFromParent';

import { Button } from '../../common/Button';
import { NothingItem } from '../NothingItem';
import NumberFormat from 'react-number-format';

import style from './index.module.css';

export const RecommendProducts: FC<{
  products: RecommendProductInfo[],
  loadingAny: boolean,
  add: Function, // TODO
  isBanningModify: boolean | undefined
}> = ({ products, loadingAny, add, isBanningModify }) => {

  useLogging('RecommendProducts', [products]);

  return products.length > 0 ? (
    <ul className={style.gridProducts}>
    {products.map((product, i) => (
      <ProductColumn product={product} loadingAny={loadingAny} add={add} key={i} isBanningModify={isBanningModify}/>
    ))}
    </ul>
  ) : (
    <NothingItem type="recommend"/>
  )
}

export const PausedProducts: FC<{
  products: ProductInfo[],
  loadingAny: boolean,
  add: Function, // TODO
  isBanningModify: boolean | undefined,
}> = ({ products, loadingAny, add, isBanningModify }) => {
  
  useLogging('PausedProducts', [products]);

  return products.length > 0 ? (
    <ul className={style.gridProducts}>
    {  products.map((product, i) => (
      <ProductColumn product={product} loadingAny={loadingAny} add={add} key={i} isBanningModify={isBanningModify}/>
    ))}
    </ul>
  ) : (
    <NothingItem type="paused"/>
  )
}

// 商品カラム
const ProductColumn: FC<{
  product: ProductInfo | RecommendProductInfo,
  loadingAny: boolean,
  key: number,
  add: Function, // TODO
  isBanningModify: boolean | undefined
}> = ({ product, loadingAny, key, add, isBanningModify }) => {

  return (
    <li className={style.productColumn} key={key}>
      <a 
        className={style.productColumn_link}
        href={product.url}
        target="_blank"
      >
        <div
          className={style.productColumn_thumbnail}
          style={product.image ? { backgroundImage: `url('${product.image}')`} : {}}
        />
      </a>

      <div className={style.productColumn_detail}>
        <h3 className={style.productColumn_title}>{product.productTitle}</h3>
        <p className={style.productColumn_price}>
          ￥<NumberFormat displayType='text' value={product.price} thousandSeparator={true}/>
        </p>
        <Button 
          type="narrow"
          onClick={() => add(product.planId, product.variantId, 1)}
          disabled={isBanningModify || loadingAny}
        >{ isBanningModify ? '現在追加できません' : '次回お届けに追加する' }</Button>
      </div>
    </li>
  );
}

export const PresaleProducts: FC<{
  extendData: ExtendData | undefined,
}> = ({ extendData }) => {

  if (!extendData) return <></>

  return extendData.presaleProducts.length > 0 ? (
    <ul className={style.gridProducts}>
    { extendData.presaleProducts.map((product, i) => (
      <li className={style.productColumn} key={i}>
        <a 
          className={style.productColumn_link}
          href={product.url}
          target="_parent"
        >
          <div
            className={style.productColumn_thumbnail}
            style={product.image ? { backgroundImage: `url('${product.image}')`} : {}}
          />
        </a>

        <div className={style.productColumn_detail}>
          <h3 className={style.productColumn_title}>{product.title}</h3>
          <p className={style.productColumn_price}>
            ￥<NumberFormat displayType='text' value={product.price} thousandSeparator={true}/>
          </p>
          <Button 
            externalLink={product.url}
            type="narrow"
          >商品詳細ページへ</Button>
        </div>
      </li>
    ))}
    </ul>
  ) : (
    <NothingItem type="presale"/>
  )
}
